import React from 'react';
import styled from 'styled-components';
import Sidebar from '../components/Sidebar';
import TopButtons from '../components/common/TopButtons';
import { useNavigate } from 'react-router-dom';
import GameList from '../components/GameList';
import { useTranslation } from 'react-i18next';

const HomeContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #0a0a1a;
  color: white;
  text-align: center;
  padding: 10px 10px;
  margin-left: 240px;
   @media (max-width: 768px) {
    margin-left: 0;
    padding-bottom: 80px;
  }
`;

const MainTitle = styled.h1`
  font-size: 30px;
  background: linear-gradient(45deg,rgb(113, 248, 212),rgb(8, 188, 140));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 5px;
   @media (max-width: 768px) {
   font-size: 30px;
  }
`;

const HomeTopButtons = styled(TopButtons)`
`;

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleConnectWallet = () => {
  };

  const handleBuyToken = () => {
    navigate('/create');
  };

  return (
    <>
      <Sidebar />
      <HomeContainer>
        <HomeTopButtons 
          onFirstButtonClick={handleConnectWallet}
          onSecondButtonClick={handleBuyToken}
        />
        
        <MainTitle>{t('home.title')}</MainTitle>
        
        <GameList />
      </HomeContainer>
    </>
  );
};

export default Home; 